var map = {
	"./Old/applePay.svg": 1899,
	"./Old/gPay.svg": 6120,
	"./Old/visa.svg": 7362,
	"./amex.svg": 961,
	"./applePay.svg": 2238,
	"./diners.svg": 5228,
	"./discover.svg": 7592,
	"./gPay.svg": 7527,
	"./generic_payment.svg": 3340,
	"./mastercard.svg": 4686,
	"./visa.svg": 6799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7963;